import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label, LabelSize } from '@as/cotopaxi';
import { Box } from '@yonderland/andes-react';
export const Field = ({ id, label, hasLabelBox, required, hasDefaultPadding = true, children, }) => {
    const renderLabel = label ? (_jsx(Label, { htmlFor: id, emphasized: true, size: LabelSize.MINOR, required: required, children: label })) : null;
    return (_jsxs(Box, { paddingBlockEnd: hasDefaultPadding ? '4' : '0', children: [label && hasLabelBox ? _jsx(Box, { paddingBlockEnd: "1", children: renderLabel }) : renderLabel, children({
                fieldId: id,
                isRequired: required,
            })] }));
};
